<template>
  <button
    type="button"
    role="switch"
    :aria-checked="isActive"
    :aria-label="title"
    :title="title"
    :disabled="isDisabled"
    class="inline-flex h-6 w-11 shrink-0 items-center rounded-full p-0.5 transition-colors duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-2"
    :class="[
      isActive ? 'bg-action' : 'bg-border-strong',
      isDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
    ]"
    @click="$emit('on-toggle')">
    <span
      class="pointer-events-none size-5 rounded-full bg-white shadow-sm transition-transform duration-200"
      :class="isActive ? 'translate-x-5' : 'translate-x-0'" />
  </button>
</template>

<script lang="ts">
export default {
  name: 'AppSwitch',

  emits: ['on-toggle'],

  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
}
</script>
